<div class="modal-header">
  <h4 class="modal-title">La session a expiré</h4> 
</div>
<div class="modal-body">
  <p>Le délai d'inactivité est dépassé. Veuillez vous reconnecter.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onOk()">Fermer</button>
</div>